import { render, staticRenderFns } from "./webinaresinternas.vue?vue&type=template&id=0534229b&scoped=true"
import script from "./webinaresinternas.vue?vue&type=script&lang=js"
export * from "./webinaresinternas.vue?vue&type=script&lang=js"
import style0 from "./webinaresinternas.vue?vue&type=style&index=0&id=0534229b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534229b",
  null
  
)

export default component.exports